import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";

export const EnumAutocomplete = ({ enumName, value, onChange }) => {
  const [_value, _setValue] = useState(value);

  return (
    <Autocomplete
      value={_value}
      fullWidth
      onChange={(event, newValue) => {
        onChange(newValue);
        _setValue(newValue);
      }}
      disableClearable
      options={Object.values(enumName).filter((v) => !isNaN(Number(v)))}
      getOptionLabel={(o) => camelCaseToCapitalizedWords(enumName[o] || "")}
      renderInput={(params) => <TextField {...params} label="Type" />}
    />
  );
};

export const TextEnumAutocomplete = ({ enumName, value, onChange, showValues = false, label = "", disabled = false}) => {
  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      disabled={disabled}
      options={Object.values(enumName)}
      getOptionLabel={(o) => showValues ? o :
         camelCaseToCapitalizedWords(Object.entries(enumName).find(([key, value]) => value === o)?.[0] || "") }
      renderInput={(params) => <TextField {...params} label={label}  />}
    />
  );
};